import { queryOptions, useQuery } from '@tanstack/react-query';
import { getValidated } from '@shared/api';
import { expenseTypeKeys } from './keys';
import { ExpenseTypesResponseSchema } from './schemas';
import { toExpenseType } from './mappers';

/**
 * The expense-type (category) reference list (`GET /api/v1/expense-type`). Categories rarely change,
 * so the query is cached for a day. Mapping in `select` keeps the DTO out of components.
 */
export const expenseTypesQueryOptions = queryOptions({
  queryKey: expenseTypeKeys.list(),
  queryFn: () => getValidated('api/v1/expense-type', ExpenseTypesResponseSchema),
  select: (res) => (res.data?.expense_types ?? []).map(toExpenseType),
  staleTime: 24 * 60 * 60 * 1000,
});

export function useExpenseTypes() {
  return useQuery(expenseTypesQueryOptions);
}
